export default {
  setAllNotifications: (state, payload) => {
    const { notificationAlert, quantityNotification } = payload;

    state.active = false;
    state.options = {};
    state.items = { 1: [], 2: [] };
    state.quantityNotification = quantityNotification;

    notificationAlert.map(item => state.items[item.type].push(item));
  },

  setAllNotificationsByUser: (state, payload) => {
    state.itemsAll = { 1: [], 2: [] };

    payload.map(item => state.itemsAll[item.type].push(item));
  },

  showNotification: (state, payload) => {
    state.active = true;
    state.options = payload;

    if (payload.showIconNotification) {
      state.items[payload.type] = [payload, ...state.items[payload.type]];
      state.quantityNotification = state.quantityNotification + 1;
    }
  },

  closeNotification: state => {
    state.active = false;
    state.options = {};
  },

  disableNotification: (state, { id, tab }) => {
    const { items } = state;

    items[tab] = items[tab].filter(item => item.id !== id);
  },

  makeReadNotifications: (state, payload) => {
    const { ids, tab } = payload;
    let count = 0;

    ids.forEach(id => {
      state.items[tab].forEach(item => {
        if (item.id === id) {
          item.dateRead = Date.now();

          count++;
        }
      });
    });

    if (state.quantityNotification > 0) {
      if (count >= state.quantityNotification) {
        state.quantityNotification = state.quantityNotification - count;
        return
      }

      state.quantityNotification = 0
    }
  }
};
